import { root } from './republish';

export const republish = {
  ...root,
};
